import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { Form, FormGroup } from 'react-bootstrap';
import { Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import PDFViewer from '../../../../../components/Image/PDF';
import PreviousValue from '../../../../../components/InputField/PreviousValue';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
import { buildAutomationChildTestId, buildAutomationValueTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';
export const QuestionRadioGroupMultiple = ({
  id,
  isDisabled,
  field,
  question,
  data,
  handleChange,
  returnsArray = false,
  hasError,
  style,
  options,
  required,
  showErr,
  error,
  prevValue,
  optionsRowClassName,
  optionClassName,
}) => {
  const fieldTestId = resolveAutomationTestId(id, field);
  const currentValue = _.get(data, field);
  const selectedValue = Array.isArray(currentValue) ? currentValue[0] : currentValue;
  const valueToLabelMap = useMemo(() => Object.fromEntries(options.map(({
    value,
    label
  }) => [value, label])), [options]);
  const {
    t
  } = useTranslation();
  const resolvedOptionsRowClassName = optionsRowClassName || 'row';
  const resolvedOptionClassName = optionClassName || 'col-12 col-md-6 mb-2';
  const hasSelection = Array.isArray(currentValue)
    ? currentValue.length > 0
    : currentValue !== undefined && currentValue !== null && currentValue !== "";
  const showSelectionError = !hasSelection && (showErr || hasError);
  const showValidationError = !showSelectionError && !isDisabled && error && showErr;
  return <div className='fv__selection-field fv__selection-field--radio mt-1 mb-2' data-testid={fieldTestId}>
        <FormGroup className='radio-multiple'>
            <Form.Label className='mt-3' style={{
        minWidth: "120px",
        padding: "0px",
        fontSize: 16,
        fontWeight: "500",
        ...style
      }}>
                {t(question)}
                {!!required ? <font color="red">*</font> : ""}
            </Form.Label>
            <div className={resolvedOptionsRowClassName}>
                {options.map((e) => {
                  const optionTestId = buildAutomationValueTestId(fieldTestId, e?.value ?? e?.label);
                  return (
                    <div key={e?.value ?? e?.label} className={resolvedOptionClassName}>
                      <Form.Check id={optionTestId} data-testid={optionTestId} type="radio" disabled={isDisabled} label={t(e.label)} name={field} value={e.value} checked={selectedValue === e.value} onChange={() => handleChange(field, returnsArray ? [e.value] : e.value)} className={`me-2 ${prevValue?.has ? "is-changed" : ""} ${isDisabled ? "is-disabled" : ""}`} />
                    </div>
                  );
                })}
            </div>
            <PreviousValue value={valueToLabelMap[Array.isArray(prevValue?.value) ? prevValue?.value[0] : prevValue?.value] ?? (Array.isArray(prevValue?.value) ? prevValue?.value[0] : prevValue?.value)} show={prevValue?.has} testId={buildAutomationChildTestId(fieldTestId, "previous")} />
            {showSelectionError && <div className="ps-0 ms-0 w-100 error__message" data-testid={buildAutomationChildTestId(fieldTestId, "error")}>{error}</div>}
            {showValidationError ? <em className="inputfield__error" data-testid={buildAutomationChildTestId(fieldTestId, "validation-error")}>
                    {error ? t(error) : "Please enter Something"}
                </em> : null}
        </FormGroup>
    </div>;
};
const Page6 = ({
  form_id,
  asLabel,
  data,
  handleChange,
  handleChangeObject,
  hasError,
  handleValidation,
  validationkeyValue
}) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeObject
  });
  return <div className='mb-3'>
            {renderWrapperField('hearAbtUs')}

            {renderWrapperField('showName', {
      className: "my-4"
    })}

            {renderWrapperField('refName', {
      className: "my-4"
    })}

            <div className='d-flex mt-4  align-items-center'>
                <Input id="REFERRAL_AND_SOURCE-tnc" data-testid="REFERRAL_AND_SOURCE-tnc" type="checkbox" checked={data?.tnc} onChange={e => {
        if (!asLabel) {
          handleChange('tnc', e.target.checked);
        }
      }} />
                <span className='ps-2'>
                    I agree to the information provided in the
                    <span style={{
          cursor: "pointer"
        }} onClick={() => {
          setModal(true);
        }} className='text-primary'> Certificate of Beneficial Owners</span>,
                    is accurate and complete to the best of my knowledge.
                </span>
            </div>

            <Modal size="xl" isOpen={modal} toggle={toggleModal} centered>
                <ModalHeader toggle={toggleModal}>Certificate of Beneficial Owners</ModalHeader>
                <ModalBody className="fv_doc_field_modal_body  ">
                    <PDFViewer modalLoader pdfStyle={{
          height: "calc(80vh - 40px)"
        }} src={`/api/application-doc/cert/beneficial-owners?form_id=${form_id}`} alt="Document" />
                </ModalBody>
            </Modal>

        </div>;
};
export default Page6;
